import { createBrowserRouter, createHashRouter, RouterProvider } from 'react-router'
import { routes } from './routes'
import { isPrototype } from './lib/env'

// The prototype is opened straight from disk, where only hash URLs survive a reload.
const router = isPrototype ? createHashRouter(routes) : createBrowserRouter(routes)

export function App() {
  return <RouterProvider router={router} />
}
